import {
  useGetTableMapByIdV2,
  useGetTableMapsV2,
  useGetTableMapsSummaryV2,
  useBulkUpdateTableMapsV2,
  TableMapDto as TableMapDtoV2,
} from '@ordr-as/ordr-service-types/epos';

export const useQueryGetTableMap = (locationId: number, zoneId?: number, tableMapId?: string, enabled = true) => {
  const { queryKey: _queryKey, ...result } = useGetTableMapByIdV2(locationId, zoneId ?? 0, tableMapId ?? '', {
    query: {
      enabled: enabled && !!locationId && !!zoneId && !!tableMapId,
      staleTime: 1000 * 60 * 5,
    },
  });
  return result;
};

export const useQueryGetTableMaps = (locationId: number, zoneId: number) => {
  const { queryKey: _queryKey, ...result } = useGetTableMapsV2(locationId, zoneId, undefined, {
    query: {
      enabled: !!locationId && !!zoneId,
    },
  });
  return result;
};

export const useQueryGetTableMapSummary = (
  locationId: number,
  zoneId?: number,
  activeOnly?: boolean,
  excludeEmptyMaps?: boolean
) => {
  const { queryKey: _queryKey, ...result } = useGetTableMapsSummaryV2(
    locationId,
    zoneId ?? 0,
    { active: activeOnly, excludeEmptyMaps },
    {
      query: {
        enabled: !!locationId && !!zoneId,
        staleTime: 1000 * 60 * 5,
      },
    }
  );
  return result;
};

export const useMutateBulkUpdateTableMaps = (locationId: number, zoneId: number) => {
  const { mutate, mutateAsync, ...rest } = useBulkUpdateTableMapsV2();

  return {
    ...rest,
    mutate: (tableMaps: TableMapDtoV2[], options?: Parameters<typeof mutate>[1]) =>
      mutate({ locationId, zoneId, data: { tableMaps } }, options),
    mutateAsync: (tableMaps: TableMapDtoV2[], options?: Parameters<typeof mutateAsync>[1]) =>
      mutateAsync({ locationId, zoneId, data: { tableMaps } }, options),
  };
};
